import { render, staticRenderFns } from "./bottom-sheet.vue?vue&type=template&id=aaec2ce0&"
import script from "./bottom-sheet.vue?vue&type=script&lang=js&"
export * from "./bottom-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports